import styled from 'styled-components';

export const Container = styled.div`
  min-width: 65px;
  height: 100%;
  display: flex;
  justify-content: flex-end;
  gap: 5px;
`;
